export const EFFECTIVENESS_CONFIG = {
  workforce: {
    number_of_medical_representatives_max: 3000,
    number_of_medical_representatives: 200,
    number_of_med_reps_for_pilot: 20,
  },
  timeline: {
    implementation_timeline_months: 12,
    number_of_months: 6,
  },
  baselines: {
    current_onboarding_cost_per_rep: 7000,
    onboarding_training_time_required_hours_rep: 150,
    rep_hourly_cost: 421.88,
    manager_hourly_rate: 60,
    average_territory_sales: 500000,
  },
  assumptions: {
    onboarding_cost_reduction_percent: 10,
    newcomers_share_percent: 10,
    onboarding_time_reduction_fresh_newcomers_percent: 30,
    onboarding_time_reduction_experienced_newcomers_percent: 10,
    percentage_of_fresh_newcomers: 70,
    percentage_of_experienced_newcomers: 30,
    manager_time_freed_hours_per_month_per_manager: 4,
    manager_span_of_control: 13,
    estimated_sales_uplift_percent: 1,
  },
  licensing: {
    licence_for_small_team: 38,
    licence_for_medium_team: 23,
    avatar_package: 350,
    avatar_package_minutes: 2000,
    avatar_minutes_per_user: 120,
  },
  pilot_setup_fees: {
    preparation_and_recommendation: 6000,
    tech_setup: 8400,
    product_setup: 2160,
  },
  rollout: {
    platform_setup_and_configuration: 68775,
  },
  organization: {
    current_annual_cost_total_organization: 5000,
    efficiency_gain_ratio: 0.2,
    estimated_penalties_prevented: 30000,
    pmcpa_violations_prevented_count: 1,
  },
};
